// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_wz3","cls2":"ProfilePdfPackCard-cls2_rtI ProfilePdfPackCard-cls1_wz3"};